// Request schema and failure copy for the native app's sign-in token exchange
// (BL-2065). One source for the route and its in-app caller (BL-2090).
import { z } from '@auctogon/core/zod';

/**
 * The one message every failed native sign-in shows: the exchange route's body
 * for any rejected token, and the app's copy when the browser sheet came back
 * without one. Never reveals why (rule #5).
 */
export const NATIVE_SIGN_IN_FAILED_MESSAGE = 'Sign-in could not be completed. Please try again.';

/**
 * The `error` the browser sheet hands the app (`<scheme>://auth?error=no_access`)
 * when the invite gate refused to create the Google account's staff user, so the
 * app shows the same no-access copy the web sign-in does (BUG-2162). Every other
 * failure stays `error=1`.
 */
export const NATIVE_NO_STAFF_ACCESS_ERROR = 'no_access';

/**
 * The `error` the browser sheet hands the app when Google's email matches a staff
 * account whose email is not verified (BUG-2299), so the app can say so instead of
 * the generic failure. Every other failure stays `error=1`.
 */
export const NATIVE_EMAIL_NOT_VERIFIED_ERROR = 'email_not_verified';

/**
 * Body of `POST /api/auth/native/exchange`: the one-use token the browser sheet
 * handed back to the app. Better Auth mints 32 characters; the upper bound only
 * stops an oversized body reaching the token hash.
 */
export const nativeAuthExchangeBodySchema = z.object({
  token: z.string().min(1).max(256),
});

/** The parsed exchange body. */
export type NativeAuthExchangeBody = z.infer<typeof nativeAuthExchangeBodySchema>;
